module.exports = __webpack_public_path__ + "img/70.91ea32d3.png";